import { useQuery } from '@tanstack/react-query';

import { personasQuery } from '../api/persona.api';

const POLL_INTERVAL_MS = 2000;

/**
 * Fetches personas and polls while any row is still being created in the background.
 * Mirrors the Content Test polling pattern: keep refetching until every persona
 * reaches a terminal creationStatus.
 */
export const usePersonasPolling = (workspaceId: string | null | undefined, enabled = true) => {
  return useQuery({
    ...personasQuery(workspaceId),
    enabled: enabled && !!workspaceId,
    staleTime: 0,
    refetchInterval: (query) => {
      const personas = query.state.data;
      if (!personas?.some((persona) => persona.creationStatus === 'processing')) {
        return false;
      }
      return POLL_INTERVAL_MS;
    },
  });
};
